import { AnalyticsEvents, track } from '@/lib/services/analytics'

export type StudyCardsSource = 'study_drafts' | 'quick_studies'

/**
 * Study cards are an enhancement under an Assistant answer: a failed read is
 * never shown to the user. It is logged for us instead (console plus the
 * existing analytics pipeline), and the cards simply do not render.
 */
export function reportStudyCardsLoadFailure(source: StudyCardsSource, threadToken: string, error: unknown) {
  const status = (error as { response?: { status?: number } } | null)?.response?.status ?? null
  const message = error instanceof Error ? error.message : String(error)
  console.warn('[study-cards] load failed', { source, threadToken, status, message })
  track(AnalyticsEvents.THREAD_STUDY_CARDS_LOAD_FAILED, { source, thread_id: threadToken, status })
}
